module.exports = __webpack_public_path__ + "static/img/zgwz.89cce78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/zgwz.jpg
// module id = MJOo
// module chunks = 1